var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8681 13.6391C10.6397 14.5139 9.13703 15.0283 7.51417 15.0283C3.36421 15.0283 0 11.6641 0 7.51417C0 3.36421 3.36421 0 7.51417 0C11.6641 0 15.0283 3.36421 15.0283 7.51417C15.0283 9.13701 14.5139 10.6397 13.6392 11.868L20 18.2289L18.2289 20L11.8681 13.6391ZM12.5228 7.51433C12.5228 10.281 10.28 12.5238 7.51335 12.5238C4.74671 12.5238 2.50391 10.281 2.50391 7.51433C2.50391 4.74769 4.74671 2.50488 7.51335 2.50488C10.28 2.50488 12.5228 4.74769 12.5228 7.51433Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a551c41c0e0950204abd64c07466627e.svg";
export { ForwardRef as ReactComponent };